import { Range, type Sequence } from "@pdfking/tfunc"

export const PageRange = (
  count: number,
  rangeFn?: (count: number) => Sequence<number>
): Sequence<number> => (rangeFn ?? (c => Range(1, c)))(count)
